import styles from './TabProductsExcluded.module.css';
import { Grid, ListItem } from '@mui/material';
import { VariantModifier } from '@/types/menus.types';

export const TabProductsModifiersExcluded = ({ variants }: { variants: VariantModifier[] }) => {
  const modifiers = variants?.sort((a, b) => a.modifierName.localeCompare(b.modifierName));
  return (
    <div className={styles.productsExcluded}>
      <div className={styles.productsExcludedInfo}>Modifiers Excluded</div>
      <span>These modifiers will not be updated for the listed stores because they are not on the menu.</span>
      <Grid container direction="row" justifyContent="space-between" alignItems="left">
        <Grid item>
          <ul>
            {modifiers
              ?.filter((modifier) => modifier.excludedStores.length > 0)
              .map((modifier) => (
                <ListItem key={modifier.variantId}>
                  <li>
                    <span className={styles.productsExcludedDescription}>
                      {modifier.modifierName}, {modifier.modifierDescription}
                    </span>
                    <ul>
                      {modifier?.excludedStores?.map((excludedStore) => (
                        <li key={excludedStore.storeGroup}>
                          <span className={styles.productsStoreGroup}>{excludedStore.storeGroup}:</span>
                          {excludedStore.stores.join(', ')}
                        </li>
                      ))}
                    </ul>
                  </li>
                </ListItem>
              ))}
          </ul>
        </Grid>
      </Grid>
    </div>
  );
};
